/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Metrics_Totals_RowInputs */



/**
* | output |
* | --- |
* | "Totals" |
*
* @param {Speakers_Metrics_Totals_RowInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_metrics_totals_row = /** @type {((inputs?: Speakers_Metrics_Totals_RowInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Metrics_Totals_RowInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Totals")
	if (locale === "de") return /** @type {LocalizedString} */ ("Totals")
	if (locale === "it") return /** @type {LocalizedString} */ ("Totals")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Totals")
	if (locale === "es") return /** @type {LocalizedString} */ ("Totals")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Totals")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Totals")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Totals")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Totals")
	return /** @type {LocalizedString} */ ("Totals")
});